/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { usePostRequest } from "../../../../api/helper";
import { selectCurrentUser } from "../../../../redux/ducks/AccessControl/slice";
import { CoverageRequirementsRedlineTreeDbItemUpdateActionType, setRedlineDatasetIdsToData, setStudyIdToTreeTypeToTree, updateDatasetsExecutionStatus } from "../../../../redux/ducks/CoverageRequirements/slice";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { CoverageRequirementsRequestOperations, formBaseCoverageRequirementsRequestUrl } from "../../CoverageRequirements/constants";
import { EDatasetExecutionStatus } from "../../CoverageRequirements/ItemDetails/constants";
import ExecutionStatus from "../../CoverageRequirements/ItemDetails/Tabs/ExecutionStatusTab/ExecutionStatus";
import StudySockets from "./StudySockets";


const JobExecutionStatus = () => {
  const dispatch = useAppDispatch()

  const [studyIds, setStudyIds] = useState<string[]>([])
  const [studyIdToName, setStudyIdToName] = useState<any>({})
  const gmid = useAppSelector((state) => selectCurrentUser(state).id)

  const getAllStudyIdsHandle = usePostRequest(formBaseCoverageRequirementsRequestUrl(CoverageRequirementsRequestOperations.GET_ALL_STUDY_IDS, null))

  const getDatasetsForAllStudies = usePostRequest(formBaseCoverageRequirementsRequestUrl(CoverageRequirementsRequestOperations.GET_DATASETS_FOR_ALL_STUDIES, null))

  const [isLoadingInitialData, setIsLoadingInitialData] = useState(false)
  useEffect(() => {
    const fetchAllStudyIds = getAllStudyIdsHandle();
    const fetchDatasetsForAllStudies = getDatasetsForAllStudies({owner: gmid});

    setIsLoadingInitialData(true)
    Promise.all([fetchAllStudyIds, fetchDatasetsForAllStudies]).then(([studyIdsResponse, datasetsResponse]) => {
      const _studyIds = Object.keys(studyIdsResponse.studyIdToName);
      setStudyIds(_studyIds);
      setStudyIdToName(studyIdsResponse.studyIdToName);

      const {datasets, trees} = datasetsResponse;
      dispatch(setStudyIdToTreeTypeToTree({actionType: CoverageRequirementsRedlineTreeDbItemUpdateActionType.UpdateAll, data: trees}));

      const _datasetIdToData: any = {}
      const _inProgressDatasetIds: any = {}
      const _datasetIdToExecutionStatus: any = {};
      datasets.forEach((dataset: any) => {
        _datasetIdToData[dataset.id] = dataset;
        if (dataset.executionStatus === EDatasetExecutionStatus.IN_PROGRESS) {
          _inProgressDatasetIds[dataset.id] = true;
        }
        _datasetIdToExecutionStatus[dataset.id] = dataset.executionStatus;
      });
      dispatch(updateDatasetsExecutionStatus(_datasetIdToExecutionStatus))

      dispatch(setRedlineDatasetIdsToData({actionType: 'replaceAll', data: _datasetIdToData}))
    }).catch((error: any) => {
      toast.error("Failed to fetch data");
    }).finally(() => {
      setIsLoadingInitialData(false)
    });
  }, []);

  return (
    <div data-no-dnd="true" style={{height: '100%', overflow: 'auto'}}>
      <StudySockets studyIds={studyIds}/>
      <div style={{overflow: 'auto', height: '100%'}}>
        <ExecutionStatus onlyShowInProgressDatasets={false} isLandingPage={true} studyIds={studyIds} studyIdToName={studyIdToName} isLoadingInitialData={isLoadingInitialData}/>
      </div>
    </div>
  )
}


export default JobExecutionStatus